import React, { useEffect, useState, useContext, useRef } from "react";
import MyContext from "../../../context/MyContext";
import TickerContext from "../../../context/ticker";

// import 'movinwords/dist/movinwords.min.css';
// import {movinwords} from 'movinwords';

//var timeOut;

const DraggableText = ({
  index,
  value,
  EditorZoom,
  setClick,
  settextData,
  TextClick,
  TickerPosition,
  click,
  customClick,
}) => {
  // const DraggableText = ({ index, value, EditorZoom, TickerPosition }) => {

  var TypeWriterPlaying = false,
    wordByWordTimeDiff = 0; //, WordByWordFadeTimeoutsArr = [], WordByWordFadeIntervalsArr = [];

  var startIndex = 0;

  const [WordByWordFadeTimeoutsArr, setWordByWordFadeTimeoutsArr] = useState(
    []
  );
  const [WordByWordFadeIntervalsArr, setWordByWordFadeIntervalsArr] = useState(
    []
  );

  const [IsPaused, setIsPaused] = useState(false);

  const {
    LayersData,
    setLayersData,
    CanvasDisplay,
    calculateTimeByWidth,
    DraggableTextRef,
    seteditableObject,
  } = useContext(MyContext);

  const { TickerStart } = useContext(TickerContext);

  const [FontAvailable, setFontAvailable] = useState(false);

  const [timeOut, settimeOut] = useState(null);

  // function sleepFor(sleepDuration) {
  //   var now = new Date().getTime();
  //   while (new Date().getTime() < now + sleepDuration) {
  //     /* Do nothing */
  //   }
  // }

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  function timers(count, bounceInMs, callback) {
    var timers = [];
    for (var i = 0; i < count; i += bounceInMs) {
      timers.push(timer(callback, i));
    }
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    return timers;
  }

  //Function to compose individual timer
  function timer(callback, delay) {
    return function () {
      WordByWordFadeTimeoutsArr.push(setTimeout(callback, delay));
    };
  }

  function isHTML(str) {
    var a = document.createElement("div");
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1 && c[i].tagName.toLowerCase() != "br") return true;
    }
    return false;
  }

  useEffect(() => {
    if (isHTML(value.text)) {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === value.key) {
          var a = document.createElement("div");
          a.innerHTML = value.text;
          array[i].text = a.firstChild.innerHTML;
        }
      }
      setLayersData(array);
    }
  }, [value.text]);

  useEffect(() => {
    // Add the font's <link> only once. This effect runs again whenever the layer data is copied
    // (every edit, slide change, undo), and each run used to add another <link> and another request.
    const href = value.googleFontSetting.googleFontUrl;
    const head = document.getElementsByTagName("head")[0];
    const exists = href && [...head.querySelectorAll('link[rel="stylesheet"]')].some((l) => l.getAttribute("href") === href);
    if (href && !exists) {
      var link = document.createElement("link");
      link.setAttribute("rel", "stylesheet");
      link.setAttribute("type", "text/css");
      link.setAttribute("href", href);
      head.appendChild(link);
    }
    var FontFaceObserver = require("fontfaceobserver");
    var font = new FontFaceObserver(value.googleFontSetting.fontName);
    font.load().then(
      function () {
        setFontAvailable(true);
      },
      function () {
        setFontAvailable(false);
      }
    );
  }, [value.googleFontSetting]);

  function resetWordsByFade(append = false) {
    if (
      value.startPositionOnTimeline + value.startTransitionWidth >=
      TickerPosition
    ) {
      if (TickerPosition - value.startPositionOnTimeline > 0 || append) {
        var StrCounter = value.WordsArray.length + 1;
        let tickerPositionInEffect =
          TickerPosition - value.startPositionOnTimeline;
        let divider = value.startTransitionWidth / StrCounter;
        let appendIndex = parseInt(tickerPositionInEffect / divider);
        let _opacity = (tickerPositionInEffect / divider) % 1;
        let $el = document.getElementById("Text-" + value.AnimationId);
        $el.innerHTML = "";
        for (const j of value.WordsArray) {
          let span = document.createElement("span");
          span.style.opacity = 0;
          span.id = j.id;
          if (j.word == "") {
            span.style.opacity = 1;
            span.setAttribute("data-empty", "1");
          }
          span.innerHTML = j.word + j.next;
          $el.appendChild(span);
        }

        for (let j = 0; j < appendIndex - 1; j++) {
          let span = document.getElementById(value.WordsArray[j].id);
          if (j == appendIndex - 2) {
            span.style.opacity = _opacity;
          } else {
            span.style.opacity = 1;
          }
        }
      }
    }
  }

  function resumeWordByWordFade(obj) {
    let span = document.getElementById(obj.id);
    resumeOpacityWordByWord(span);
  }

  function resumeOpacityWordByWord(span) {
    let opacity = Number(
      window.getComputedStyle(span).getPropertyValue("opacity")
    );
    if (opacity < 1 && opacity > 0) {
      let interval;
      if (span && !span.getAttribute("data-empty")) {
        interval = setInterval(() => {
          if (opacity < 1) {
            opacity = opacity + value.wordByWordFadeInData.opacityIncrement; //0.03;
            span.style.opacity = opacity;
          } else {
            clearInterval(interval);
          }
        }, value.wordByWordFadeInData.perWordFPS); //60

        WordByWordFadeIntervalsArr.push(interval);
        setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        wordByWordTimeDiff =
          wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
      }
    } else if (opacity == 0) {
      if (span && !span.getAttribute("data-empty")) {
        animateWordOpacity(span);
      }
    }
  }

  function triggerWordByWordFade($el, obj) {
    // setTimeout(() => {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      span.style.opacity = 0;
      if (obj.word == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      }
      span.innerHTML = obj.word + obj.next;
      $el.appendChild(span);
      // const id = window.requestAnimationFrame(step);
      // Ids = id;
      if (span && !span.getAttribute("data-empty")) {
        animateWordOpacity(span);
      }
    }
    // }, wordByWordTimeDiff);
  }

  function animateWordOpacity(span) {
    WordByWordFadeTimeoutsArr.push(
      setTimeout(() => {
        let interval;
        let opacity = Number(
          window.getComputedStyle(span).getPropertyValue("opacity")
        );

        if (span && !span.getAttribute("data-empty")) {
          interval = setInterval(() => {
            if (opacity < 1) {
              opacity = opacity + value.wordByWordFadeInData.opacityIncrement; //0.03
              span.style.opacity = opacity;
            } else {
              clearInterval(interval);
            }
          }, value.wordByWordFadeInData.perWordFPS); //60
          WordByWordFadeIntervalsArr.push(interval);
          setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        }
      }, wordByWordTimeDiff)
    );
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    wordByWordTimeDiff =
      wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
  }

  //WordByWord Appear Code Starts from here
  function triggerWordByWordAppear($el, obj) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      span.style.opacity = 0;
      if (obj.word == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        span.style.color = "transparent";
        span.style.textShadow = `0 0 10px ${value.textColor}`;
        span.style.fontSize = value.fontSize + 10 + "px";
      }
      span.innerHTML = " " + obj.word + obj.next;
      $el.appendChild(span);
      if (span && !span.getAttribute("data-empty")) {
        animateWordAppear(span);
      }
    }
  }

  function animateWordAppear(span) {
    WordByWordFadeTimeoutsArr.push(
      setTimeout(() => {
        let interval;
        let fontSize = Number(
          window
            .getComputedStyle(span)
            .getPropertyValue("font-size")
            .split("px")[0]
        );
        let textShadow = 10;
        if (span && !span.getAttribute("data-empty")) {
          span.style.opacity = 1;
          interval = setInterval(() => {
            if (fontSize > value.fontSize) {
              fontSize = fontSize - value.wordByWordFadeInData.scaleDecriment;
              textShadow =
                textShadow - value.wordByWordFadeInData.scaleDecriment;
              span.style.fontSize = fontSize + "px";
              span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
            } else {
              span.style.position = "";
              //span.innerHTML = span.innerHTML.split(" ")[1] + " ";
              // span.style.display = '';
              clearInterval(interval);
            }
          }, value.wordByWordFadeInData.perWordFPS); //60
          WordByWordFadeIntervalsArr.push(interval);
          setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        }
      }, wordByWordTimeDiff)
    );
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    wordByWordTimeDiff =
      wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //value.wordByWordFadeInData.perWordMS; //500;
  }

  function resetWordsByAppear(append = false) {
    if (
      value.startPositionOnTimeline + value.startTransitionWidth >=
      TickerPosition
    ) {
      if (TickerPosition - value.startPositionOnTimeline > 0 || append) {
        var StrCounter = value.WordsArray.length + 1;
        let tickerPositionInEffect =
          TickerPosition - value.startPositionOnTimeline;
        let divider = value.startTransitionWidth / StrCounter;
        let appendIndex = parseInt(tickerPositionInEffect / divider);
        let _opacity = (tickerPositionInEffect / divider) % 1;
        let $el = document.getElementById("Text-" + value.AnimationId);
        $el.innerHTML = "";
        for (const j of value.WordsArray) {
          let span = document.createElement("span");
          span.style.opacity = 0;
          span.id = j.id;
          if (j.word == "") {
            span.style.opacity = 1;
            span.setAttribute("data-empty", "1");
          } else {
            span.style.position = "relative";
            span.style.color = "transparent";
            span.style.textShadow = `0 0 10px ${value.textColor}`;
            span.style.fontSize = value.fontSize + 10 + "px";
          }
          span.innerHTML = " " + j.word + j.next;
          $el.appendChild(span);
        }

        for (let j = 0; j < appendIndex - 1; j++) {
          let span = document.getElementById(value.WordsArray[j].id);
          span.style.opacity = 1;
          if (j == appendIndex - 2) {
            //span.style.opacity = _opacity;

            let fontSize =
              Number(span.style.fontSize.split("px")[0]) - _opacity * 10;
            let textShadow = 10 - _opacity * 10;
            span.style.fontSize = fontSize + "px";
            span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
          } else {
            span.style.position = "";
            span.style.fontSize = "";
            span.style.textShadow = "";
            span.style.color = "";
            span.innerHTML = span.innerHTML.split(" ")[1] + " ";
          }
        }
      }
    }
  }

  function resumeWordByWordAppear(obj) {
    let span = document.getElementById(obj.id);
    resumeAppearWordByWord(span);
  }

  function resumeAppearWordByWord(span) {
    let opacity = Number(
      window.getComputedStyle(span).getPropertyValue("opacity")
    );
    let fontSize = parseInt(
      window.getComputedStyle(span).getPropertyValue("font-size").split("px")[0]
    );
    let TextShadow = window
      .getComputedStyle(span)
      .getPropertyValue("text-shadow");
    // if(TextShadow != "none"){
    //   debugger
    //   let TextShadow = window.getComputedStyle(span).getPropertyValue("text-shadow").split(" ")[5].split("px")[0];
    //   console.log("TextShadow: ",TextShadow);
    // }
    let textShadow = 10;
    if (TextShadow != "none") {
      textShadow = Number(
        window
          .getComputedStyle(span)
          .getPropertyValue("text-shadow")
          .split(" ")[5]
          .split("px")[0]
      );
    }
    if (fontSize > value.fontSize && TextShadow != "none" && textShadow != 10) {
      let interval;
      if (span && !span.getAttribute("data-empty")) {
        span.style.opacity = 1;
        interval = setInterval(() => {
          if (fontSize > value.fontSize) {
            fontSize = fontSize - value.wordByWordFadeInData.scaleDecriment;
            textShadow = textShadow - value.wordByWordFadeInData.scaleDecriment;
            span.style.fontSize = fontSize + "px";
            span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
          } else {
            span.style.position = "";
            // span.innerHTML = span.innerHTML.split(" ")[1] + " ";
            clearInterval(interval);
          }
        }, value.wordByWordFadeInData.perWordFPS); //60
        WordByWordFadeIntervalsArr.push(interval); //60

        setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        //wordByWordTimeDiff = wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
      }
    } else {
      if (span && !span.getAttribute("data-empty")) {
        //console.log(wordByWordTimeDiff);
        //console.log("calling animateWordAppear");
        animateWordAppear(span);
      }
    }
  }

  //Text Bounce in animation

  function triggerLetterBouncing($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 0;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        if (calledForPlay) {
          span.style.top = value.fontSize + "px";
        }
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);

      // if (span && !span.getAttribute("data-empty")) {
      //   animateLetterBounce(span);
      // }
    }
  }
  function animateLetterBounce() {
    for (let i = 0; i < value.CharactersArray.length; i++) {
      let span = document.getElementById(value.CharactersArray[i].id);
      if (
        span &&
        !span.getAttribute("data-empty") &&
        !span.getAttribute("data-doneBounce")
      ) {
        startIndex = i;
        break;
      }
    }
    let reachedToTop = false;
    let fontSizeDivider = value.fontSize / 4;
    let bounceInMs = value.bounceInMs / 13;
    let totalTime =
      totalTimeToMs(
        calculateTimeByWidth(
          value.startTransitionWidth + value.startPositionOnTimeline
        )
      ) - totalTimeToMs(calculateTimeByWidth(TickerPosition)); //value.bounceInMs * value.cleanCharacterArray.length;
    var set = timers(totalTime, bounceInMs, bounce);

    function bounce() {
      if (!value.player) {
        return;
      }

      let span = document.getElementById(value.CharactersArray[startIndex].id);
      span.style.opacity = 1;
      let top = Number(
        window.getComputedStyle(span).getPropertyValue("top").split("px")[0]
      );

      if (!reachedToTop && top >= 0 - value.fontSize) {
        if (top - fontSizeDivider == 0) {
          top = top - (fontSizeDivider + 1);
        } else {
          top = top - fontSizeDivider;
        }

        if (top <= 0 - value.fontSize) {
          reachedToTop = true;
        }
      } else {
        top = top + fontSizeDivider;
        if (top > 0) {
          top = 0;
        }
      }
      span.style.top = top + "px";

      if (
        top == 0 &&
        reachedToTop &&
        startIndex < value.CharactersArray.length - 1
      ) {
        if (startIndex == value.CharactersArray.length - 1) {
          // for (const i of WordByWordFadeIntervalsArr) {
          //   clearInterval(i);
          // }
          return;
        }
        startIndex++;
        span.setAttribute("data-doneBounce", 1);
        reachedToTop = false;
      }
    }

    for (var i = 0; i < set.length; i++) {
      set[i]();
    }
    // WordByWordFadeIntervalsArr.push(interval)
  }

  // function animateLetterBounce() {
  //   var S = new Date;
  //   for (let i = 0; i < value.CharactersArray.length; i++) {
  //     let span = document.getElementById(value.CharactersArray[i].id);
  //     if (span && !span.getAttribute("data-empty") && !span.getAttribute("data-doneBounce")) {
  //       startIndex = i;
  //       break;
  //     }
  //   }
  //   let reachedToTop = false;
  //   let fontSizeDivider = value.fontSize / 4;
  //   let bounceInMs = value.bounceInMs / 12;
  //   // if (bounceInMs < 10) {
  //   //   bounceInMs = 10;
  //   //   fontSizeDivider = value.fontSize * 3;
  //   // }

  //   let interval = setInterval(() => {
  //     let span = document.getElementById(value.CharactersArray[startIndex].id);
  //     span.style.opacity = 1;
  //     let top = Number(window.getComputedStyle(span).getPropertyValue("top").split('px')[0]);

  //     if (!reachedToTop && top >= 0 - value.fontSize) {
  //       if (top - fontSizeDivider == 0) {
  //         top = top - (fontSizeDivider + 1);
  //       }
  //       else {
  //         top = top - fontSizeDivider;
  //       }

  //       if (top <= 0 - value.fontSize) {
  //         reachedToTop = true;
  //       }
  //     }
  //     else {
  //       top = top + fontSizeDivider;
  //       if (top > 0) {
  //         top = 0;
  //       }
  //     }
  //     span.style.top = top + "px";
  //     if (top == 0 && reachedToTop && startIndex < value.CharactersArray.length - 1) {
  //       if (startIndex == value.CharactersArray.length - 1) {
  //         for (const i of WordByWordFadeIntervalsArr) {
  //           clearInterval(i);
  //         }
  //         return;
  //       }
  //       startIndex++;
  //       span.setAttribute("data-doneBounce", 1);
  //       reachedToTop = false;
  //     }
  //   }, (new Date - S) / 1000);
  //   WordByWordFadeIntervalsArr.push(interval)
  // }

  // Type Writer animation
  function triggerTypeWriter($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 0;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);
    }
  }
  function animateTypeWriter() {
    for (let i = 0; i < value.CharactersArray.length; i++) {
      let span = document.getElementById(value.CharactersArray[i].id);
      if (
        span &&
        !span.getAttribute("data-empty") &&
        !span.getAttribute("data-doneBounce")
      ) {
        startIndex = i;
        break;
      }
    }
    let bounceInMs = value.bounceInMs;
    if (bounceInMs < 10) {
      bounceInMs = 10;
    }

    let interval = setInterval(() => {
      let span = document.getElementById(value.CharactersArray[startIndex].id);
      span.style.opacity = 1;

      if (startIndex == value.CharactersArray.length - 1) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        return;
      }
      startIndex++;
      span.setAttribute("data-doneBounce", 1);
    }, bounceInMs);
    WordByWordFadeIntervalsArr.push(interval);
  }
  function resetTypeWriterAndBounce() {
    if (
      value.startPositionOnTimeline + value.startTransitionWidth >=
      TickerPosition
    ) {
      if (TickerPosition - value.startPositionOnTimeline > 0) {
        var txt = value.originalText;
        var StrCounter = txt.length + 1;

        let tickerPositionInEffect =
          TickerPosition - value.startPositionOnTimeline;
        let divider = value.startTransitionWidth / StrCounter;
        let appendIndex = parseInt(tickerPositionInEffect / divider);
        let $el = document.getElementById("Text-" + value.AnimationId);
        if ($el) {
          $el.innerHTML = "";
          for (let j = 0; j < value.CharactersArray.length; j++) {
            let obj = value.CharactersArray[j];
            if (obj) {
              let span = document.createElement("span");
              span.id = obj.id;
              if (j < appendIndex - 1) {
                span.style.opacity = 1;
                span.setAttribute("data-doneBounce", 1);
              } else {
                span.style.opacity = 0;
              }
              if (obj.character == "") {
                span.style.opacity = 1;
                span.setAttribute("data-empty", "1");
              } else {
                span.style.position = "relative";
              }
              span.innerHTML = obj.character + obj.next;
              $el.appendChild(span);
            }
          }
        }
      }
    }
  }

  //Text Rolling Effect

  function rollSpan(span) {
    let angle = Number(
      window
        .getComputedStyle(span)
        .getPropertyValue("transform")
        .split("(")[1]
        .split("deg")[0]
    );
  }

  function triggerLetterRolling($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 1;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        span.style.display = "inline-block";
        span.style.transform = "rotate(360deg)";
        if (calledForPlay) {
          span.style.left = value.fontSize * 3 + "px";
        }
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);

      if (span && !span.getAttribute("data-empty")) {
        rollSpan(span);
      }
    }
  }

  useEffect(() => {
    if (value.InClass == "animated WordByWordFade ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (const i of WordByWordFadeTimeoutsArr) {
          clearTimeout(i);
        }
      } else if (TickerPosition > value.startPositionOnTimeline) {
        //&& TickerPosition - value.startPositionOnTimeline > 1
        if (value.text == "") {
          // value.text = value.originalText;
          resetWordsByFade(false);
        }
        for (let i of value.WordsArray) {
          resumeWordByWordFade(i);
        }
      } else if (
        TickerPosition <= value.startPositionOnTimeline &&
        value.text == ""
      ) {
        if (value.draggedBeforeStartPos) {
          resetWordsByFade(true);
          for (let i of value.WordsArray) {
            resumeWordByWordFade(i);
          }
        } else {
          let $el = document.getElementById("Text-" + value.AnimationId);
          let check = true;
          for (let i of value.WordsArray) {
            let span = document.getElementById(i.id);
            if (span) {
              check = false;
              break;
            }
          }
          if (check) {
            $el.innerHTML = "";
            for (let i of value.WordsArray) {
              triggerWordByWordFade($el, i);
            }
          }
        }
      }
    } else if (value.InClass == "animated WordByWordAppear ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (const i of WordByWordFadeTimeoutsArr) {
          clearTimeout(i);
        }
      } else if (TickerPosition > value.startPositionOnTimeline) {
        //&& TickerPosition - value.startPositionOnTimeline > 1
        if (value.text == "") {
          resetWordsByAppear(false);
        }
        for (let i of value.WordsArray) {
          resumeWordByWordAppear(i);
        }
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        // && value.text == ""
        // if (value.draggedBeforeStartPos) {
        //   resetWordsByFade();
        //   for (let i of value.WordsArray) {
        //     resumeWordByWordFade(i);
        //   }
        // }
        // else {
        let $el = document.getElementById("Text-" + value.AnimationId);
        let check = true;
        for (let i of value.WordsArray) {
          let span = document.getElementById(i.id);
          if (span) {
            check = false;
            break;
          }
        }
        if (check) {
          $el.innerHTML = "";
          for (let i of value.WordsArray) {
            triggerWordByWordAppear($el, i);
          }
        }
        // }
      }
    } else if (value.InClass == "animated TextBounce ") {
      if (!value.player) {
        // for (const i of WordByWordFadeIntervalsArr) {
        //   clearInterval(i);
        // }
        for (const i of WordByWordFadeTimeoutsArr) {
          clearTimeout(i);
        }
        // let $el = document.getElementById(value.TextId);
        // $el.innerHTML = '';
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 1;
            span.style.top = "0px";
          }
        }
      } else if (
        TickerPosition > value.startPositionOnTimeline &&
        TickerPosition - value.startPositionOnTimeline > 1
      ) {
        if (
          value.CharactersArray.length > 0 &&
          !document.getElementById(value.CharactersArray[0].id)
        ) {
          resetTypeWriterAndBounce();
        }
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 0;
            span.style.top = value.fontSize + "px";
          }
        }
        animateLetterBounce();
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        let $el = document.getElementById("Text-" + value.AnimationId);
        $el.innerHTML = "";
        for (let i of value.CharactersArray) {
          triggerLetterBouncing($el, i, true);
        }
        animateLetterBounce();
      }
    } else if (value.InClass == "animated TypeWriter ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 1;
          }
        }
      } else if (
        TickerPosition > value.startPositionOnTimeline &&
        TickerPosition - value.startPositionOnTimeline > 1
      ) {
        if (
          value.CharactersArray.length > 0 &&
          !document.getElementById(value.CharactersArray[0].id)
        ) {
          resetTypeWriterAndBounce();
        }
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 0;
          }
        }
        animateTypeWriter();
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        let $el = document.getElementById("Text-" + value.AnimationId);
        $el.innerHTML = "";
        for (let i of value.CharactersArray) {
          triggerTypeWriter($el, i, true);
        }
        animateTypeWriter();
      }
    } else if (value.InClass == "animated Rolling ") {
      let $el = document.getElementById("Text-" + value.AnimationId);
      $el.innerHTML = "";
      for (let i of value.CharactersArray) {
        triggerLetterRolling($el, i, true);
      }
    }
  }, [value.player]);

  useEffect(() => {
    let $el = document.getElementById("Text-" + value.AnimationId);
    if ($el) {
      if (value.InClass == "animated TypeWriterr ") {
        if (!TypeWriterPlaying) {
          // _paused = false
          setIsPaused(false);
          TypeWriterPlaying = true;

          var i = 0;
          var txt = $el.innerHTML;
          var speed = 50;

          $el.innerHTML = "";
          function typeWriter() {
            if (!CanvasDisplay) {
              if (i < txt.length) {
                let textToAppend = txt.charAt(i);
                if (
                  txt.charAt(i) == "<" &&
                  txt.charAt(i + 1).toLocaleLowerCase() == "b" &&
                  txt.charAt(i + 2).toLocaleLowerCase() == "r" &&
                  txt.charAt(i + 3).toLocaleLowerCase() == ">"
                ) {
                  textToAppend = "<br>";
                  $el.innerHTML += textToAppend;
                  i = i + 4;
                } else if (
                  txt.charAt(i) == "&" &&
                  txt.charAt(i + 1).toLocaleLowerCase() == "n" &&
                  txt.charAt(i + 2).toLocaleLowerCase() == "b" &&
                  txt.charAt(i + 3).toLocaleLowerCase() == "s" &&
                  txt.charAt(i + 4).toLocaleLowerCase() == "p" &&
                  txt.charAt(i + 5).toLocaleLowerCase() == ";"
                ) {
                  textToAppend = "&nbsp;";
                  $el.innerHTML += textToAppend;
                  i = i + 6;
                } else {
                  $el.innerHTML += txt.charAt(i);
                  i++;
                }
                settimeOut(setTimeout(typeWriter, speed));
                // timeOut = setTimeout(typeWriter, speed);
              }
            }
          }
          typeWriter();
        }
      } else if (value.InClass == "animated WordByWordFade ") {
        // let check = true;
        // for (let i of value.WordsArray) {
        //   let span = document.getElementById(i.id);
        //   if (span) {
        //     check = false;
        //     break;
        //   }
        // }
        // if (check) {
        //   $el.innerHTML = '';
        //   for (let i of value.WordsArray) {
        //     triggerWordByWordFade($el, i);
        //   }
        // }
      }
    }
  }, [value.InClass]);

  useEffect(() => {
    if (CanvasDisplay && timeOut) {
      clearTimeout(timeOut);
      TypeWriterPlaying = false;
      // _paused = true;
      setIsPaused(true);
    }
    if (!CanvasDisplay && IsPaused) {
      // _paused = false
      setIsPaused(false);
      let $el = document.getElementById("Text-" + value.AnimationId);
      if ($el) {
        if (value.InEffect == "animated TypeWriter ") {
          if (!TypeWriterPlaying) {
            TypeWriterPlaying = true;
            var i = $el.innerHTML.length;
            var txt = value.originalText;
            var speed = 50;
            // $el.innerHTML = '';
            function typeWriter() {
              if (!CanvasDisplay) {
                if (i < txt.length) {
                  let textToAppend = txt.charAt(i);
                  if (
                    txt.charAt(i) == "<" &&
                    txt.charAt(i + 1).toLocaleLowerCase() == "b" &&
                    txt.charAt(i + 2).toLocaleLowerCase() == "r" &&
                    txt.charAt(i + 3).toLocaleLowerCase() == ">"
                  ) {
                    textToAppend = "<br>";
                    $el.innerHTML += textToAppend;
                    i = i + 4;
                  } else if (
                    txt.charAt(i) == "&" &&
                    txt.charAt(i + 1).toLocaleLowerCase() == "n" &&
                    txt.charAt(i + 2).toLocaleLowerCase() == "b" &&
                    txt.charAt(i + 3).toLocaleLowerCase() == "s" &&
                    txt.charAt(i + 4).toLocaleLowerCase() == "p" &&
                    txt.charAt(i + 5).toLocaleLowerCase() == ";"
                  ) {
                    textToAppend = "&nbsp;";
                    $el.innerHTML += textToAppend;
                    i = i + 6;
                  } else {
                    $el.innerHTML += txt.charAt(i);
                    i++;
                  }

                  settimeOut(setTimeout(typeWriter, speed));
                  // timeOut = setTimeout(typeWriter, speed);
                }
              }
            }
            typeWriter();
          }
        }
      }
    }
  }, [CanvasDisplay]);

  // var element = document.getElementsByClassName('single-resizer')[index]

  // useEffect(() => {

  //   if (element != undefined) {
  //     // debugger
  //     // if (element.nextSibling.classList.includes('textUppperDiv')) {
  //     //   alert('yes')
  //     // }

  //     element.addEventListener('dblclick', function () {
  //       settextData(value);
  //       TextClick();
  //     })
  //     return () => {
  //       if (element)
  //         element.removeEventListener('dblclick', console.log('Remove'))
  //     }
  //   }

  // }, [element])

  useEffect(() => {
    const _customClick = customClick();
    if (value.Editable) {
      var element = document.getElementsByClassName("single-resizer");
      for (let SubElement of element) {
        if (SubElement.firstChild) {
          if (!SubElement.classList.contains("RectBorder")) {
            //SubElement.style.zIndex = 3000
            SubElement.classList.add("RectBorder");
          }
        }
      }
    } else {
      var element = document.getElementsByClassName("single-resizer")[0];
      if (element) {
        //  debugger
        element.removeEventListener("dblclick", dblcheck);
      }
    }

    return () => {
      var element = document.getElementsByClassName("single-resizer")[0];
      if (element) {
        element.removeEventListener("dblclick", dblcheck);

        // debugger
        if (value.Editable) {
          element.ondblclick = function () {
            dblcheck();
          };
          //console.log("Click from DraggableText", _customClick);

          // if (click >= 2) {
          //   element.ondblclick();
          //   setClick(0);
          // }
        } else {
          setClick(0);
        }
      }
    };
  }, [value.Editable]);

  const dblcheck = () => {
    alert("checkTrackText");
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        if (array[i].originalText) {
          array[i].text = array[i].originalText;
        }
        if (array[i].originalFontSize) {
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].edit = "true";
        array[i].FurtherSetting = true;
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
  };

  return (
    <>
      {FontAvailable && (
        <span
          key={index}
          // id={value.TextId}
          id={"Text-" + value.AnimationId}
          ref={DraggableTextRef}
          style={{
            textDecoration: value.textDec,
            fontStyle: value.Fontstyle,
            fontSize: Math.round((value.fontSize * EditorZoom) / 100) + "px",
            fontWeight: value.fontWeight,
            opacity: value.opacity,
            color: value.textColor,
            overflowWrap: "break-word",
            fontFamily: value.googleFontSetting.fontName,
            transformOrigin: `top left`,
            width: (value.width * EditorZoom) / 100,
            lineHeight: value.LineHeight,
            transformOrigin: "center",
            letterSpacing: value.LetterSpacing + "em",
            // maxWidth: value.width,
            // transform: !CanvasDisplay ? ` rotate(${value.rotateAngle}deg)` : "",
            transform: value.flip
              ? value.flip +
                (!CanvasDisplay
                  ? ` rotate(${value.rotateAngle}deg) scale(${value.scale})`
                  : `scale(${value.scale})`)
              : !CanvasDisplay
              ? ` rotate(${value.rotateAngle}deg) scale(${value.scale})`
              : `scale(${value.scale})`,
          }}
          // onClick={e =>{
          //   debugger
          //   dblcheck()
          // }}
          tabIndex="0"
          className="textInput"
          spellCheck="false"
          dangerouslySetInnerHTML={{ __html: value.text }}
        />
      )}
    </>
  );
};
export default DraggableText;
